if (typeof window !== 'undefined') {
    module.exports = window.React;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react/index.js
// module id = 0
// module chunks = 0